import React from "react";
import useReveal from "../hooks/useReveal";

// Wraps children and fades + slides them up the first time they scroll into view.
export default function Reveal({ children, delay = 0, y = 26, className }) {
  const [ref, shown] = useReveal();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: shown ? 1 : 0,
        transform: shown ? "none" : `translateY(${y}px)`,
        transition: `opacity .7s ease ${delay}ms, transform .85s cubic-bezier(.2,.7,.2,1) ${delay}ms`,
        willChange: "opacity, transform",
      }}
    >
      {children}
    </div>
  );
}
